import { App } from 'vue';
import { IgcSnackbarService } from './IgcSnackbarService';

// declare module 'vue/types/vue' {
//   interface Vue {
//     // @ts-ignore
//     $igcSnackbar: IgcSnackbarService;
//   }
// }

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $igcSnackbar: IgcSnackbarService;
  }
}

export const SnackbarPlugin = {
  install: (app: App, options: any) => {
    app.config.globalProperties.$igcSnackbar = new IgcSnackbarService();
  },
};
